export default __webpack_public_path__ + "static/media/c001-student-2.098cd059.jpg";